import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageAdminsChild from "./ManageAdminsChild";

const ManageAdmins = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageAdminsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageAdmins;
